import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CancelStatusComponent } from './cancel-status.component';
import {ReservationService} from '../reservations.service';
import {FormsModule} from '@angular/forms';
import {Trip2ThemeModule} from '../../../trip2-theme/trip2-theme.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    Trip2ThemeModule
  ],
  declarations: [CancelStatusComponent],
  exports: [CancelStatusComponent],
  providers: [
    ReservationService
  ]
})
export class CancelStatusModule { }



// WEBPACK FOOTER //
// ./src/app/pages/trip-reservations/cancel-status/cancel-status.module.ts